import React from 'react';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Head from 'next/head';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import Button from 'react-bootstrap/Button';
import { FaTimes } from 'react-icons/fa';
import { ParallaxProvider } from 'react-scroll-parallax';
import Footer from '@/components/common/widgets/Footer';
import Layout from '@/components/common/layouts/Layout';
import HeroSection from '@/components/homepage/HeroSection';
import PostCallToAction from '../PostCallToAction';

function FourthPost() {
  return (
    <Layout>
      <Head>
        <title>10 Ways to Cure Boredom that You Probably Didn't Think Of</title>
        <meta name="description" content="Blog post by Avery Gann, a Mini. " />

      </Head>
      <ParallaxProvider>
        <HeroSection
          image="/images/whatsnewimages/chalk.jpg"
          alt="Blue chalk in hand"
          topSpace={(
            <div>
              <br />
            </div>
                    )}
          title={"10 Ways to Cure Boredom that You Probably Didn't Think Of"}
          description="By: Avery Gann"
          otherContent=""
        />
      </ParallaxProvider>
      <div className="privacy-style">

        <Container className="post-style">
          <p>
            I know what it’s like to be home for the majority of your week and bored out of your mind. In an effort to make all of us go a little less crazy, I made a list of 10 ways to cure boredom that you probably didn’t think of.
          </p>
          <p>
            <h5>1. Put Beads/Braids in Your Hair</h5>
            This is aimed mainly at people with long hair. One of my friends did this with me, and it was super easy. We bought ivory beads for $2.00 at Hobby Lobby, and with a paperclip, a simple braid, and patience, you can have one too (the paperclip makes it easy to hook the hair and pull it through the bead).
          </p>
          <p>
            <h5>2. Buy a Fish, a Duck, or a Chicken</h5>
            A PetCo trip seems to be in my future as one of my close friends now has a strong desire to become the mother of a fish. My other friend, Noah, has a strange obsession with raising either a baby chick or a baby duck. Unfortunately, that’s a big undertaking for him, so he would like me to raise it so that he can visit it every so often… I’m not on board with that arrangement. But, if you have the time to take care and enough love for a new tiny animal, then maybe getting a fish, duck, or chicken would be a great fit for you. I know that you can get one of the two birds for about 69¢ a few miles down the road from my house. Happy parenting!
          </p>
          <p>
            <h5>3. Host an Olympic Game Night with your Family</h5>
            Now, I don’t know how many of you have seen The Office, but during Season 2, Episode 3 the entire office hosted a do it yourself Olympics where they all competed against each other sparking alliances and rivalries. The games could be anything from who can eat a fruit roll up the fastest to getting an Oreo from your forehead to your mouth without touching it to a homemade ring toss. Be creative! You can make a game out of a lot of things that are just lying around your house.
          </p>
          <p>
            <h5>4. Have a Chopped Competition</h5>
            Easy concept, difficult execution. Chopped used to be my favorite show on the Food Network, and basically what it entails is three to four random ingredients that you already have in your house in one cohesive meal. You can either do this alone or against someone. May the best dish win!
          </p>
          <p>
            <h5>5. Make a Bad Film</h5>
            Every child has done this at some point. We all went through a phase where we thought we were the next Steven Spielberg and Meryl Streep combined. We made bad films and then subjected our parents to watching them and putting on a great smile with a happy “you’re doing amazing, sweetie!” So pick up that camera (probably a phone) and make a film - even if it’s bad. Your parents will love it anyway.
          </p>
          <p>
            <h5>6. Follow a Bob Ross Tutorial in Chalk</h5>
            The man, the myth, the legend… Bob Ross! People watched his landscapes of “happy accidents” in the 80s, and in the last decade, an entirely new generation has begun to appreciate his tutorials. Just painting Bob Ross’s incredible works seems too easy, so we recommend you go sit on the sidewalk, soak up some rays, and draw a breathtaking mountain of hard work in chalk that will disappear with only a little rain.
          </p>
          <p>
            <h5>7. Break a World Record</h5>
            Here’s another challenge for you. Look up Guinness World Records on Google and pick one to get really good at. Or, better yet, make a new one up yourself. And if the satisfaction of your ego knowing that you’re the best isn’t enough, then apply online and actually break the record. This is a long process, but long processes can cure boredom, right?
          </p>
          <p>
            <h5>8. Become TikTok Famous</h5>
            It’s VERY easy to go viral on tiktok. If you’re bored at home, try challenging yourself to make a short funny video to see if you can hack the algorithm and become an overnight sensation.
          </p>
          <p>
            <h5>9. Plan a Whole Trip with a PowerPoint</h5>
            I have done this a good few times in my life, and, yes, I’m painfully aware that it’s incredibly dumb. I’m telling you to voluntarily plan a vacation that you will most likely not be going on. This sounds weird, but can actually be fun and make you feel accomplished afterwards. Figure out where you want to go and plan everything from flights to hotels to car rides to food to activities. Bonus points if you make a PowerPoint with your plan and present it to someone. I once planned out a four day hypothetical trip to New York with three Broadway shows for my mom and me on a $1,000 budget!
          </p>
          <p>
            <h5>10. Guess Who? (With Friends or Celebrities)</h5>
            Some of you may have heard of the game Guess Who. If you haven’t, it’s basically a game where you have 24 people in front of you and you have to guess which person the other player has by asking questions. If you have this game, you should try cutting out a bunch of tiny pictures of either celebrities or friends of yours and putting them on the game instead of the generic people that come in the box. This will guarantee laughter as you’d be describing experiences and personalities of the people instead of physical features.
          </p>
          <p>
            Hopefully some of these can cure your boredom!
          </p>
          <p>
            Disclaimer: If you do any of these things on our recommendation and it goes wrong in any way, we, the Big & Mini Team, are not liable. Although we do feel bad and also slightly flattered that you actually took one of these crazy pieces of advice. Good luck, stay safe, don’t hurt yourself!
          </p>
        </Container>
        <PostCallToAction />
        <Footer />
      </div>
    </Layout>
  );
}

export default FourthPost;
